import { observable, makeObservable, action } from 'mobx';
import { MultibetState } from 'src/domains/sportsbook/betting/state/multibetState/MultibetState';
import { BetslipCommandType } from 'src/domains/sportsbook/betting/state/multibetState/Types';
import { Common } from 'src/domains/common/Common';
import { TrpcClient } from 'src/appState/TrpcClient';

export class MultibetWidgetState {
    @observable public isConfirmationOpened: boolean = false;
    @observable public isLoading: boolean = false;
    @observable public error: string | null = null;

    private readonly trpcClient: TrpcClient;

    public constructor(
        private readonly multibetState: MultibetState,
        common: Common,
        private readonly internalEventId: number,
        private readonly eventName: string,
        private readonly sport: string
    ) {
        makeObservable(this);
        this.trpcClient = common.trpcClient;
    }

    @action
    private setLoading = (loading: boolean): void => {
        this.isLoading = loading;
    };

    @action
    private setError = (error: string | null): void => {
        this.error = error;
    };

    public onAddToBetslipInner = async (command: BetslipCommandType): Promise<void> => {
        if (command.sportsbookFixtureId === undefined || command.sportsbookFixtureId === '') {
            this.setError('Missing fixture ID');
            return;
        }

        if (command.marketId === undefined || command.marketId === null) {
            this.setError('Missing market ID');
            return;
        }

        if (command.marketId == this.multibetState.activeBets[0]?.marketId) {
            this.setError('Identical bet can not be added to bet slip');
            return;
        }

        try {
            this.setLoading(true);
            this.setError(null);

            const result = await this.trpcClient.client.betBuilder.getMultibetSelections.query({
                marketId: command.marketId,
            });

            if (result.type === 'error') {
                this.setError(result.message);

                return;
            }

            const enrichedCommand: BetslipCommandType = {
                ...command,
                selections: result.data.selections,
                internalEventId: this.internalEventId,
                eventName: this.eventName,
                sport: this.sport,
            };

            this.multibetState.addToBetslip(enrichedCommand);

            this.isConfirmationOpened = true;

            setTimeout(() => {
                this.isConfirmationOpened = false;
            }, 3000);
        } catch (error) {
            this.setError(error instanceof Error ? error.message : 'Unknown error');
        } finally {
            this.setLoading(false);
        }
    };

    public onAuthenticationError = (): void => {
        this.setError('Authentication required');
    };
}
